/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { dateFormat } from "~/constants/dateFormats";
import { createCountFilterDefinition } from "~/hooks/useAppliedFilters/definitionFactories";
import { AppliedFilterDefinition } from "~/hooks/useAppliedFilters/types";
import { QueryState } from "~/hooks/useQueryState/useQueryState";
import { ResourceDetailsResourceGroupsQuery } from "../../types/ResourceDetailsResourceGroupsQuery";

type DefinitionKey = "dateCreated" | "createdBy";

type ResourceGroupsQueryState = ResourceDetailsResourceGroupsQuery & QueryState;

type Definition = AppliedFilterDefinition<
  ResourceGroupsQueryState,
  DefinitionKey
>;

export const resourceDetailsResourceGroupsAppliedFilters: Definition[] = [
  {
    key: "dateCreated",
    label: "Date Created",
    enableValuePopover: false,
    getValues: (queryState) =>
      queryState.startDateUTC && queryState.endDateUTC
        ? [queryState.startDateUTC, queryState.endDateUTC]
        : [],
    getValueDisplay: (queryState) =>
      `${dayjs(queryState.startDateUTC).format(dateFormat.shortDate)} - ${dayjs(
        queryState.endDateUTC
      ).format(dateFormat.shortDate)}`,
    clear: () => ({
      startDateUTC: undefined,
      endDateUTC: undefined,
    }),
  },
  createCountFilterDefinition<ResourceGroupsQueryState, "createdBy">({
    key: "createdBy",
    label: "Created By",
    labels: { singular: "Creator", plural: "Creators" },
    getValues: (queryState) => queryState.createdBy,
    getExcluded: (queryState) => queryState.excludeCreatedBy,
    clear: () => ({ createdBy: undefined, excludeCreatedBy: undefined }),
    applyValuesPatch: (queryState, values) => ({
      createdBy: values.length ? values : undefined,
      excludeCreatedBy: values.length ? queryState.excludeCreatedBy : undefined,
    }),
  }),
];
